import React, { useEffect } from "react"
import { HashRouter as Router } from "react-router-dom"
import { message } from "antd"

import "./App.css"

import Provider from "./Provider"
import { GlobalStoreProvider } from "./Store"
import { suppressResizeObserverErrors } from "./utils/resizeObserverUtils"

message.config({
	top: 30,
	maxCount: 3,
})

function App() {
	// Initialize global ResizeObserver error suppression
	useEffect(() => {
		const cleanup = suppressResizeObserverErrors()
		return cleanup
	}, [])

	return (
		/* for enabling global store */
		<GlobalStoreProvider>
			{/* For enabling hash routing */}
			<Router>
				<Provider />
			</Router>
		</GlobalStoreProvider>
	)
}

export default App
